import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ExpandToggle from './ExpandToggle';
import toggleExpandItem from '../../../../actions/uiState/toggleExpandItem';

const mapDispatchToProps = dispatch => bindActionCreators({ toggleExpandItem }, dispatch);

const mapStateToProps = ({ estimateBuilder }, ownProps) => {
  const isOpen = estimateBuilder.uiState.expandedItems.indexOf(ownProps.itemId) !== -1;
  return {
    isOpen,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExpandToggle);
